import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { api, useResource } from 'app';
import Form, { Field, Submit } from 'packages/form';
import { Container } from 'components/Page';
import AudienceInput from 'components/Campaign/AudienceInput';
import AvailableAudience from './AvailableAudience';

function EditCampaignAudienceForm({ campaignId }) {
  const campaign = useResource('campaign', 'single', `/advertising-campaigns/${campaignId}`);
  const filters = useResource(
    'campaignFilter',
    'collection',
    `/advertising-campaigns/${campaignId}/filters`
  );

  const campaignData = campaign.body.data;

  const initialValues = {
    filters: filters.body
  };

  const handleSubmit = formData => {
    const data = formData.filters.map(item => ({
      ...item,
      filter_params: {
        ...item.filter_params
      }
    }));

    return api
      .post(`/advertising-campaigns/${campaignId}/filters`, data)
      .then(response => response.json());
  };

  return (
    <Container>
      <Form initialValues={initialValues} name="updateCampaignAudience" onSubmit={handleSubmit}>
        <Field
          campaignId={campaignId}
          channel={campaignData.channel}
          maximumIntendedReceivers={campaignData.maximum_intended_receivers}
          component={AudienceInput}
          name="filters"
        />

        <div>
          <Submit text="ذخیره تفییرات دریافت‌کنندگان" />
          &nbsp;&nbsp;
          <AvailableAudience channel={campaignData.channel} campaignId={campaignId} />
        </div>
      </Form>
    </Container>
  );
}

function EditCampaignAudience({ campaignId }) {
  return (
    <Suspense fallback={'...'}>
      <EditCampaignAudienceForm campaignId={campaignId} />
    </Suspense>
  );
}

EditCampaignAudience.propTypes = {
  campaignId: PropTypes.number.isRequired
};

export default EditCampaignAudience;
